import React from 'react';
import { clsx } from 'clsx';
import { DateText, SubTitle, Title } from '@/components/atoms/Sidebar';
import styles from './Result.module.scss';

const View: React.FC<{
  onClick?: () => void;
  head: string;
  sub?: string;
  date?: string;
  active?: boolean;
}> = ({ onClick, head, sub, date, active }) => {
  const className = clsx(
    styles.container,
    onClick != null ? styles.clickable : '',
    active === false ? styles.noBorder : '',
  );
  return (
    <button
      className={className}
      onClick={onClick}
      data-cy="CardView"
    >
      <Title label={head} />
      {sub && <SubTitle label={sub} />}
      {date && <DateText label={date} />}
    </button>
  );
};

export default View;
